import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: { },
    currentList: []
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setCurrentList (state, list) {
      state.currentList = list
    }
  },
  actions: {
    async storeReviewApplicationList ({rootState, commit}) {
      commit('setCurrentList', await api.getReviewApplications(rootState.project.current._id))
    },
    async storeReviewApplication ({commit, rootState}, _id) {
      commit('setCurrent', await api.getReviewApplication(_id))
    },
    async add ({rootState, state, dispatch, commit}) {
      const newReviewApplication = {...state.current}
      await api.addReviewApplication({
        ...newReviewApplication,
        project: rootState.project.current._id
      })

      await dispatch('storeReviewApplicationList')
    },
    async patch ({ state, dispatch, commit }) {
      const newReviewApplication = {...state.current}

      await api.updateReviewApplication(newReviewApplication)

      await dispatch('storeReviewApplicationList')
    },
    async download ({rootState, state}) {
      let i = 1
      const result = await api.downloadReviewApplication(rootState.project.current._id, state.currentList.map(item => {
        item.no = i
        i++
        return item
      }))
      require('downloadjs')(result, `材料設備送審管制表.docx`)
    },
    async delete ({state, dispatch}, id) {
      await api.deleteReviewApplication(id)
      await dispatch('storeReviewApplicationList')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reviewApplication.js